












































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Api from "@/api";
import Multiselect from "vue-multiselect";
import { AxiosResponse } from "axios";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import Table from "@/components/Common/Table.vue";

import swal from "sweetalert";
import "vue-slider-component/theme/default.css";
import {
  BookingStatus,
  EventTimeframe,
  ICustomerGroup,
  IEventBooking,
  IPagination,
  ITableParams,
  ICustomerType
} from "@/interface";

interface IFilter {
  timeFrames: Array<EventTimeframe>;
  customer_type_id: number | null;
  customer_group_id: number | null;
  status: Array<BookingStatus>;
  origin_booking_id: number | null;
}

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    Table,
    Multiselect,
    AlertBox
  }
})
export default class BookingEvents extends Vue {
  public loading = false;
  public updating = false;
  private showSearchModal = false;
  private componentKey = 0;
  private bookings: Array<IEventBooking> = [];
  private failedRequest = false;
  private metaData: ITableParams | null = null;
  private fetchParams: IPagination = {
    page: 1,
    per_page: null,
    search: ""
  };
  private customer_typeOptions: Array<ICustomerType> = [
    { name: "Privat", id: 1 },
    { name: "Firma", id: 2 },
    { name: "Verein", id: 3 },
    { name: "Kindergarten", id: 4 },
    { name: "Schule", id: 5 },
    { name: "Hobby", id: 6 }
  ];
  private statuses: Array<BookingStatus> = [];
  private eventTimeframes: Array<EventTimeframe> = [];
  private customer_groups: Array<ICustomerGroup> = [];
  private filter: IFilter = {
    timeFrames: [],
    customer_type_id: null,
    customer_group_id: null,
    status: [],
    origin_booking_id: null
  };

  private beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: this) => {
      if (vm.$route.query.event_booking_deleted === "true") {
        swal("Success!", "The event booking was canceled.", "success").then(
          () => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          }
        );
      }
      vm.getBookings(() => {
        //
      });
      vm.getGroups();
      vm.getBookingStatuses();
      vm.getEventTimeframes();
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any) {
    if (to.query.event_booking_deleted === "true") {
      swal("Success!", "The event booking was canceled.", "success").then(
        () => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        }
      );
    }
    this.forceRerender();
    if (
      this.fetchParams.per_page !== null &&
      this.fetchParams.per_page !== undefined &&
      this.fetchParams.to !== null &&
      this.fetchParams.to !== undefined &&
      this.fetchParams.page !== undefined &&
      this.fetchParams.to % this.fetchParams.per_page === 0 &&
      this.fetchParams.page !== 1
    ) {
      this.fetchParams.page -= 1;
    }
    this.getBookings(() => {
      //
    });
    this.getGroups();
    this.getBookingStatuses();
    this.getEventTimeframes();
    next();
  }

  private openModal(): void {
    this.showSearchModal = true;
  }

  private closeModal(): void {
    this.showSearchModal = false;
    this.filter = {
      timeFrames: [],
      customer_type_id: null,
      customer_group_id: null,
      status: this.statuses,
      origin_booking_id: null
    };
  }

  private handleSearch(): void {
    this.getBookings();
    this.showSearchModal = false;
  }

  private getBookings(successCallback?: any): void {
    this.loading = true;
    this.bookings = [];
    const endpoint = this.$partnerEndpoint("bookings/events");

    Api()
      .get(endpoint, {
        params: {
          page: this.fetchParams.page,
          search: this.fetchParams.search,
          per_page: this.fetchParams.per_page,
          ...this.filter
        }
      })
      .then((response: AxiosResponse) => {
        this.bookings = response.data.data;
        this.metaData = response.data.meta;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
        this.loading = false;
      })
      .catch(() => {
        this.failedRequest = true;
        this.loading = false;
      });
  }

  private cancelBooking(eventBooking: { booking: IEventBooking }): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The event booking will be cancelled",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint = this.$partnerEndpoint(
          "bookings/" + eventBooking.booking.id
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "BookingEvents",
                query: { event_booking_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The event booking was deleted.", "success");
                  this.getBookings(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete external events.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getGroups(): void {
    const endpoint: string = this.$partnerEndpoint("groups");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.customer_groups = response.data.data;
      });
  }

  private getBookingStatuses(): void {
    const endpoint: string = this.$partnerEndpoint("bookings/statuses");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.statuses = response.data.data;
        this.filter.status = this.statuses;
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getEventTimeframes(): void {
    const endpoint: string = this.$partnerEndpoint("events/timeframes");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.eventTimeframes = response.data.data;
      });
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }
}
